import axios from "axios";
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getPosts = async (token) => {
    try {
        const response = await heyapi.get(
            `/writer/post/all`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getPostDetails = async (token, postid) => {
    try {
        const response = await heyapi.get(
            `/writer/post/details/${postid}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const addCompany = async (token, name, logopath, linkedinUrl) => {
    try {
        const response = await heyapi.post(
            `/writer/company/add`,
            {name, logopath, linkedinUrl},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

//add update company function
export const updateCompany = async (token, companyId, name, logopath, linkedinUrl) => {
    try {
        const response = await heyapi.put(
            `/writer/company/update/${companyId}`,
            { name, logopath, linkedinUrl },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

//write for mail organizations
export const addMailOrganization = async (token, payload) => {
    try {
        const response = await heyapi.post(
            `/writer/mailorg/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};
//add for edit mail organization
export const updateMailOrganization = async (token, orgId, payload) => {
    try {
        const response = await heyapi.put(  
            `/writer/mailorg/update/${orgId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }   
};
//add to send mail to mailOrganization
export const sendPromoMailOrganization = async (token, orgId) => {
    try {
        console.log("Sending promo mail to organization ID:", orgId);
        const response = await heyapi.post(
            `/writer/mailorg/sendpromomail`,    
            {mailOrgId: orgId},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

//write all mail organizations
export const allMailOrganizations = async (token) => {
    try { 
        const response = await heyapi.get(
            `/writer/mailorg/all`,
            {
                headers: {  
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getAllCompanies = async (token, name) => {
    try {
        const response = await heyapi.get(
            `/writer/company/all`,
            name,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getPostDetailsFromSlug = async (slug) => {
    try {
        const response = await heyapi.get(
            `/post/${slug}`,
            {
                
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getPostList = async (slug) => {
    try {
        const response = await heyapi.get(
            `/post/list`,
            {
                
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const addSkill = async (token, name) => {
    try {
        const response = await heyapi.post(
            `/writer/skill/add`,
            {name},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};

export const getAllSkills = async (token, name) => {
    try {
        const response = await heyapi.get(
            `/writer/skill/all`,
            name,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};


export const addPost = async (
  postId,
  title,
  company,
  skills,
  locations,
  workType,
  numOpening,
  startDate,
  duration, //selectedMonth, //num of months 
  responsibility,
  stipend,
  perksState, //perks
  ppo,
  mobile,
  contactEmail,
  extLink,  
  token
) => {

  console.log(
    postId,
    title,
    company,
    skills,
    locations,
    workType,
    numOpening,
    startDate,
    duration, //selectedMonth, //num of months 
    responsibility,
    stipend,
    perksState, //perks
    ppo,
    mobile,
    contactEmail,
    extLink,  
  );
  try {
    const response = await heyapi.post(
      `/writer/post/add`,
      {
        postId,
        title,
        company,
        skills,
        locations,
        workType,
        numOpening,
        duration,
        startDate,
        responsibility,
        stipend,
        perksState,
        ppo,
        mobile, 
        contactEmail, 
        extLink
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response);
    return response;
  } catch (err) {
    console.error("API error:", err);
    throw new Error("Failed to add post. Please try again later.");
  }
};
